import { Controller } from 'stimulus';

class AlertController extends Controller {
  show() {
    this.element.classList.remove('is-hidden');

    setTimeout(() => {
      this.element.classList.add('is-hidden');
    }, 2000);
  }
}

AlertController.targets = [];

export default AlertController;
